<template>
  <v-app id="inspire" style="background: #f8f9fb">
    <v-main>
      <v-container class="fill-height" fluid>
        <v-row align="center" justify="center">
          <v-col cols="12" sm="8" md="4">
            <app-header />
            <v-card class="auth-card mx-auto" max-width="460" elevation="0">
              <div class="auth-head">
                <h2 class="auth-title">Reset password</h2>
                <p class="auth-sub">Enter the code and your new password</p>
              </div>
              <v-form v-model="valid" ref="form">
                <v-text-field
                  id="otp"
                  label="OTP"
                  type="number"
                  v-model="otp"
                  :rules="[required('OTP')]"
                  prepend-inner-icon="mdi-security"
                  outlined
                  dense
                ></v-text-field>

                <v-text-field
                  id="password"
                  label="Password"
                  name="new-password"
                  prepend-inner-icon="mdi-lock-outline"
                  :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                  :type="show ? 'text' : 'password'"
                  v-model="password"
                  :rules="[
                    required('password'),
                    minLength('password', 8),
                    lowerCaseFormat(),
                    upperCaseFormat(),
                    digitFormat(),
                    specialCharFormat(),
                  ]"
                  counter="true"
                  @click:append="show = !show"
                  outlined
                  dense
                ></v-text-field>

                <v-text-field
                  id="confirm-new-password"
                  label="Confirm password"
                  name="confirmedPassword"
                  prepend-inner-icon="mdi-lock-outline"
                  :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                  :type="show1 ? 'text' : 'password'"
                  v-model="confirmedPassword"
                  :rules="[
                    required('confirm password'),
                    confirmPassword('password', password),
                  ]"
                  counter="true"
                  @click:append="show1 = !show1"
                  outlined
                  dense
                ></v-text-field>

                <v-btn
                  id="submit"
                  block
                  large
                  class="auth-btn mt-2"
                  @click="createPassword"
                  :disabled="!valid"
                  :loading="loading"
                  >Submit Password</v-btn
                >

                <div class="tw-flex tw-justify-center mt-4">
                  <a
                    id="otp-resend"
                    class="auth-link"
                    href="#"
                    @click.prevent="resendOtp"
                    >{{ resend }}</a
                  >
                </div>

                <div class="tw-flex tw-justify-center tw-items-center mt-3">
                  <span class="grey--text body-2 mr-2"
                    >Already have an account?
                  </span>
                  <router-link to="/" class="auth-link">Login</router-link>
                </div>
              </v-form>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
    <app-bottom />
  </v-app>
</template>

<script>
import validations from '@/utils/Validations'
import { mapGetters, mapState } from 'vuex'
export default {
  components: {
    appHeader: () => import('@/components/Logo'),
    appBottom: () => import('@/components/BottomImage'),
  },
  props: {
    source: String,
  },
  data() {
    return {
      valid: false,
      otp: '',
      password: '',
      confirmedPassword: '',
      show: false,
      show1: false,
      ...validations,
      resend: 'Resend OTP',
      username: '',
    }
  },
  watch: {
    async password() {
      await this.$nextTick()
      this.$refs.form.validate()
    },
  },
  mounted() {
    const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
    const param = this.$route.query.user
    if (!param || !regex.test(param)) {
      this.$router.push({ name: 'ForgotPassword' }).catch(() => {})
    }
    this.username = param
    this.$store.dispatch('auth/clearAuthenticationStatus')
  },

  computed: {
    ...mapState(['loading']),
    ...mapGetters('auth', ['hasAuthenticationStatus', 'authenticationStatus']),
  },

  methods: {
    async createPassword() {
      this.$store.state.loading = true
      await this.$store
        .dispatch('auth/confirmPasswordReset', {
          username: this.username,
          code: this.otp,
          password: this.password,
        })
        .then(() => {
          this.$store.state.loading = false
          if (this.hasAuthenticationStatus) {
            if (this.authenticationStatus.variant === 'error') {
              this.$store.commit('SNACKBAR', this.authenticationStatus)
            } else {
              this.$store.commit('SNACKBAR', this.authenticationStatus)
              this.$router.push({ name: 'SignIn' }).catch(() => {})
            }
          }
        })
    },
    async resendOtp() {
      this.resend = 'Resending OTP...'
      await this.$store
        .dispatch('auth/passwordReset', {
          username: this.username,
        })
        .then(() => {
          if (this.hasAuthenticationStatus) {
            this.$store.commit('SNACKBAR', this.authenticationStatus)
          }
          this.resend = 'Resend OTP'
        })
    },
  },
}
</script>

<style scoped>
.auth-card {
  border-radius: 18px;
  border: 1px solid #e8edf5;
  background: #ffffff;
  box-shadow: 0 18px 48px rgba(15, 42, 85, 0.12);
  padding: 28px 30px 30px;
}
.auth-head {
  text-align: center;
  margin-bottom: 18px;
}
.auth-title {
  font-size: 22px;
  font-weight: 800;
  color: #0f2a55;
  margin: 0;
}
.auth-sub {
  font-size: 13px;
  color: #6b7a90;
  margin-top: 4px;
}
.auth-link {
  color: #034ea2;
  font-weight: 600;
  font-size: 13px;
  text-decoration: none;
}
.auth-link:hover {
  text-decoration: underline;
}
.auth-btn {
  background: linear-gradient(135deg, #034ea2 0%, #0a63c4 100%) !important;
  color: #ffffff !important;
  border-radius: 10px;
  font-weight: 700;
  letter-spacing: 0.3px;
  box-shadow: 0 8px 20px rgba(3, 78, 162, 0.3);
}
.auth-btn.v-btn--disabled {
  background: #e6ebf3 !important;
  color: #4b5a70 !important;
  box-shadow: none;
}
/* Soft rounded inputs */
.auth-card ::v-deep .v-text-field--outlined .v-input__slot {
  border-radius: 10px;
}
.auth-card ::v-deep .v-text-field--outlined fieldset {
  border-color: #d6deea;
}
.auth-card ::v-deep .v-text-field--outlined.v-input--is-focused fieldset {
  border-color: #034ea2;
}
</style>
